const settings = {

    //DDCAnywhere Dev Settings
    authority: 'https://ddcanywhereqa.ddc.nycnet/',
    redirect_uri: 'https://localhost:3000/',
    post_logout_redirect_uri: 'https://localhost:3000/',
    client_id: 'Benchmark',
  

  //DDCAnywhere Staging Settings
    // authority: 'https://ddcanywhere.nyc/',
    // redirect_uri: 'https://benchmarkqa.ddcanywhere.nyc/',
    // post_logout_redirect_uri: 'https://benchmarkqa.ddcanywhere.nyc/',
    // client_id: 'BenchmarkTraining',


  //DDCAnywhere Production Settings
    // authority: 'https://ddcanywhere.nyc/',
    // redirect_uri: 'https://benchmark.ddcanywhere.nyc/',
    // post_logout_redirect_uri: 'https://benchmark.ddcanywhere.nyc/',
    // client_id: 'Benchmark',

  //Prutechlab QA Settings
  //authority: "https://dev.ddcanywhere.prutechlab.com/",
  //redirect_uri: "https://benchmarkqa.ddcanywhere.nyc/",
  //post_logout_redirect_uri: "https://benchmarkqa.ddcanywhere.nyc/",

  // these two will be done dynamically from the buttons clicked, but are
  // needed if you want to use the silent_renew
    response_type: 'id_token token',
  //scope: "openid profile benchmarkAPI",
    scope: 'openid profile benchmarkAPI',
  // silent renew will get a new access_token via an iframe 
  // just prior to the old access_token expiring (60 seconds prior)
  // silent_redirect_uri: window.location.protocol + "//" + window.location.host + "/silent_renew.html",
  // automaticSilentRenew: false,

  // will raise events for when user has performed a logout at IdentityServer
    monitorSession : true,

  // this will allow all the OIDC protocol claims to vbe visible in the window. normally a client app 
  // wouldn't care about them or want them taking up space
    filterProtocolClaims: true,

  // this will use the user info endpoint if it's an OIDC request and there's an access_token
    loadUserInfo: true
};


if (process.env.REACT_APP_ENV === 'staging') {
    settings.authority = 'https://ddcanywhere.nyc/';
    settings.redirect_uri = 'https://benchmarkqa.ddcanywhere.nyc/';
    settings.post_logout_redirect_uri =  'https://benchmarkqa.ddcanywhere.nyc/';
    settings.client_id = 'BenchmarkTraining';
}

if (process.env.REACT_APP_ENV === 'production') {
    settings.authority = 'https://ddcanywhere.nyc/';
    settings.redirect_uri = 'https://benchmark.ddcanywhere.nyc/';
    settings.post_logout_redirect_uri = 'https://benchmark.ddcanywhere.nyc/';
    settings.client_id = 'Benchmark';
}

if (process.env.REACT_APP_ENV === 'qa') {
  settings.authority = 'https://staging.ddcanywhere.nyc/';
  settings.redirect_uri = 'https://bmqa.ddcanywhere.nyc/';
  settings.post_logout_redirect_uri = 'https://bmqa.ddcanywhere.nyc/';
  settings.client_id = 'benchmarkQa';
  settings.scope = 'openid profile benchmarkAPI benchmarkqaApi prokXApi';
}

export default settings;


// authority: 'https://ddcanywhereqa.ddc.nycnet/',
// redirect_uri: 'https://localhost:3000/',
// post_logout_redirect_uri: 'https://localhost:3000/',
// client_id: 'Benchmark',
// response_type: 'id_token token',,
// scope: 'openid profile benchmarkAPI',